import Store from '@/store/index';

export default {
  data: function() {
    return {
      
    };
  },
	methods: {
		zeroPadding(n) {
      return ('00' + n).slice(-2);
    },
		getFirstDateOfWeek(d) {
      const date = new Date(d);
      const day = d.getDay();
      const diff = d.getDate() - day;
      date.setDate(diff)
      return date;
    },
		getFirstMonthOfThree(d) {
      const date = new Date(d);
      const month = Math.floor(d.getMonth() / 3) * 3
      date.setMonth(month);
      return date;
    },
		getDateObj(d) {
      if (typeof d === 'string') {
        const year = d.substring(0, 4);
        const month = d.substring(4, 6);
        const date = d.substring(6, 8);
        const hour = d.substring(8, 10);
        if (hour) {
          d = new Date(year, month - 1, date, hour);
        } else {
          d = new Date(year, month - 1, date);
        }
      }
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const date = d.getDate();
      const day = d.getDay();
      const days = [ '日', '月', '火', '水', '木', '金', '土' ];
      const hour = d.getHours();
      return { year, month, date, day: days[day], hour };
    },
		getDate(d) {
      if (typeof d === 'string') {
        /*
         * '20200810'와 같은 형식의 경우
         */
				if(d.length == 8) {
					const year = d.substring(0, 4);
					const month = d.substring(4, 6);
					const date = d.substring(6, 8);
					return new Date(year, month - 1, date);
				} else {
					const year = d.substring(0, 4);
					const month = d.substring(4, 6);
					const date = d.substring(6, 8);
					const hour = d.substring(8, 10);
					return new Date(year, month - 1, date, hour);
				}
      } else {
        /*
         * { year: 2020, month: 8, date: 10 }와 같은 형식의 경우
         */
        if (d.hour) {
          return new Date(d.year, d.month - 1, d.date, d.hour);
        } else {
          return new Date(d.year, d.month - 1, d.date);
        }
      }
    },
		getMonthStr(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      return '' + year + month;
    },
    getDateStr(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      const date = this.zeroPadding(d.getDate());
      return '' + year + month + date;
    },
    getDateHourStr(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      const date = this.zeroPadding(d.getDate());
      const hours = this.zeroPadding(d.getHours());
      return '' + year + month + date + hours + '00';
    },
		getFromDateValue(d, mode) {
			let result = d.hour 
				? new Date(d.year, d.month - 1, d.date, d.hour) 
				: new Date(d.year, d.month - 1, d.date);
			let fromValue;
			switch (mode) {
				case 'hour':
					fromValue = this.getDateHourStr(result);
          break;
        case 'day':
					fromValue = this.getDateStr(result);
          break;
        case 'week':
					fromValue = this.getDateStr(result);
          break;
        case 'month':
					fromValue = this.getMonthStr(result);
          break;
        case 'three':
					fromValue = this.getMonthStr(result);
          break;
        default:
          break;
			}
			return fromValue;
		},
		getToDateValue(d, mode) {
			if (typeof d === 'string') {
        /*
         * '20200810'와 같은 형식의 경우
         */
        const year = d.substring(0, 4);
        const month = d.substring(4, 6);
        const date = d.substring(6, 8);
        const result = new Date(year, month - 1, date);
				return this.calculateToDate(result, mode, this.axisNum);
      } else { // { year: 2020, month: 8, date: 10 }와 같은 형식의 경우
				let toValue;
				if (d.hour) {
          const result = new Date(d.year, d.month - 1, d.date, d.hour);
          return this.calculateToDate(result, mode, this.axisNum);
        } else {
          const result = new Date(d.year, d.month - 1, d.date);
					return this.calculateToDate(result, mode, this.axisNum);
        }
			}
		},
		makeDateList(str) {
			return new Promise((resolve, reject) => {
				let result = [];
				let startDate = new Date(`${str.substring(0,4)}-${str.substring(4,6)}-${str.substring(6,8)}T00:00:00`);
				for(let i = 0; i < 10; i++) {
					if(i == 0) {
						result.push(str);
					} else {
						let temp = new Date(startDate.setDate(startDate.getDate() + 1));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let tempStr = `${year}${month}${day}`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			});
		},
		makeAxisDateList(str, axisNum) {
			return new Promise((resolve, reject) => {
				let result = [];
				let startDate = new Date(`${str.substring(0,4)}-${str.substring(4,6)}-${str.substring(6,8)}T00:00:00`);
				for(let i = 0; i < axisNum; i++) {
					if(i == 0) {
						result.push(str);
					} else {
						let temp = new Date(startDate.setDate(startDate.getDate() + 1));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let tempStr = `${year}${month}${day}`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			});
		},
		makeHourList(date) {
			return new Promise((resolve, reject) => {
				let result = [];
				let monthValue = date.month;
				monthValue = monthValue >= 10 ? monthValue : `0${monthValue}`;
				let dayValue = date.date;
				dayValue = dayValue >= 10 ? dayValue : `0${dayValue}`;
				let hourValue = date.hour;
				hourValue = hourValue >= 10 ? hourValue : `0${hourValue}`;
				let startDate = new Date(`${date.year}-${monthValue}-${dayValue}T${hourValue}:00:00`);
				for(let i = 0; i < 10; i++) {
					if(i == 0) {
						result.push(`${date.year}${monthValue}${dayValue}${hourValue}00`);
					} else {
						let temp = new Date(startDate.setHours(startDate.getHours() + 1));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let hour = temp.getHours();
						hour = hour >= 10 ? hour : `0${hour}`;
						let tempStr = `${year}${month}${day}${hour}00`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			});
		},
		makeAxisHourList(date, axisNum, type) {
			return new Promise((resolve, reject) => {
				let result = [];
				let monthValue = date.month;
				monthValue = monthValue >= 10 ? monthValue : `0${monthValue}`;
				let dayValue = date.date;
				dayValue = dayValue >= 10 ? dayValue : `0${dayValue}`;
				let hourValue = date.hour;
				hourValue = hourValue >= 10 ? hourValue : `0${hourValue}`;
				let startDate = new Date(`${date.year}-${monthValue}-${dayValue}T${hourValue}:00:00`);
				for(let i = 0; i < axisNum; i++) {
					if(i == 0) {
						let tempStr = type == 'chart' 
							? `${date.year}${monthValue}${dayValue}${hourValue}00` 
							: `${date.year}${monthValue}${dayValue}${hourValue}`;
						result.push(tempStr);
					} else {
						let temp = new Date(startDate.setHours(startDate.getHours() + 1));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let hour = temp.getHours();
						hour = hour >= 10 ? hour : `0${hour}`;
						let tempStr = type == 'chart' ? `${year}${month}${day}${hour}00` : `${year}${month}${day}${hour}`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			});
		},
		makeAxisWeekList(str, axisNum) {
			return new Promise((resolve, reject) => {
				let result = [];
				let startDate = new Date(`${str.substring(0,4)}-${str.substring(4,6)}-${str.substring(6,8)}T00:00:00`);
				for(let i = 0; i < axisNum; i++) {
					if(i == 0) {
						result.push(str);
					} else {
						let temp = new Date(startDate.setDate(startDate.getDate() + 7));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let tempStr = `${year}${month}${day}`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			});
		},
		calculateToDate(date, mode, axisNum) {
			let tempDate = date;
			let toValue;
			switch (mode) {
				case 'hour':
					tempDate.setHours(tempDate.getHours() + axisNum - 1);
          toValue = this.getDateHourStr(tempDate); 
          break;
        case 'day':
					tempDate.setDate(tempDate.getDate() + axisNum - 1);
          toValue = this.getDateStr(tempDate); 
          break;
        case 'week':
					tempDate.setDate(tempDate.getDate() + 41);
          toValue = this.getDateStr(tempDate); 
          break;
        case 'month':
					tempDate.setMonth(tempDate.getMonth() + axisNum - 1);
          toValue = this.getMonthStr(tempDate); 
          break;
        case 'three':
					tempDate.setMonth(tempDate.getMonth() + 17);
          toValue = this.getMonthStr(tempDate); 
          break;
        default:
          break;
			}
			return toValue;
		},
		makeChart(findIndex, item) {
			const authorities = Store.getters.getAuthorities;
			const anonymous = Store.getters.getAnonymousDisplayEnable;
			if(findIndex != -1) {
				this.visitorDataset.datasets[0].data.push(item.Data.known);
				if(anonymous) this.visitorDataset.datasets[1].data.push(item.Data.unknown);
				this.visitorDataset.labels.push(this.makePercentage(item.Data.known, item.Data.known + item.Data.unknown));

				this.genderDataset.datasets[0].data.push(item.Data.female.total);
				this.genderDataset.datasets[1].data.push(item.Data.male.total);
				this.genderDataset.labels.push([item.Data.male.ratio + '%', item.Data.female.ratio + '%']);
				this.manAndWomanRatioList.push([
					`${item.Data.male.ratio}%`,
					`${item.Data.male.ratioByAge[0]}%`,
					`${item.Data.male.ratioByAge[1]}%`,
					`${item.Data.male.ratioByAge[2]}%`,
					`${item.Data.male.ratioByAge[3]}%`,
					`${item.Data.male.ratioByAge[4]}%`,
					`${item.Data.male.ratioByAge[5]}%`,
					`${item.Data.male.ratioByAge[6]}%`,
          `${item.Data.female.ratio}%`,
					`${item.Data.female.ratioByAge[0]}%`,
					`${item.Data.female.ratioByAge[1]}%`,
					`${item.Data.female.ratioByAge[2]}%`,
					`${item.Data.female.ratioByAge[3]}%`,
					`${item.Data.female.ratioByAge[4]}%`,
					`${item.Data.female.ratioByAge[5]}%`,
					`${item.Data.female.ratioByAge[6]}%`,
				])

				this.repeaterDataset.datasets[0].data.push(item.Data.newCustomer.total);
				this.repeaterDataset.datasets[1].data.push(item.Data.repeater.total);
				this.repeaterDataset.labels.push([item.Data.repeater.ratio + '%', item.Data.newCustomer.ratio + '%']);
				this.newOrRepeatCustomersRatioList.push([
          `${item.Data.repeater.ratio}%`,
					`${item.Data.repeater.ratioByAge[0]}%`,
					`${item.Data.repeater.ratioByAge[1]}%`,
					`${item.Data.repeater.ratioByAge[2]}%`,
					`${item.Data.repeater.ratioByAge[3]}%`,
					`${item.Data.repeater.ratioByAge[4]}%`,
					`${item.Data.repeater.ratioByAge[5]}%`,
					`${item.Data.repeater.ratioByAge[6]}%`,
          `${item.Data.newCustomer.ratio}%`,
					`${item.Data.newCustomer.ratioByAge[0]}%`,
					`${item.Data.newCustomer.ratioByAge[1]}%`,
					`${item.Data.newCustomer.ratioByAge[2]}%`,
					`${item.Data.newCustomer.ratioByAge[3]}%`,
					`${item.Data.newCustomer.ratioByAge[4]}%`,
					`${item.Data.newCustomer.ratioByAge[5]}%`,
					`${item.Data.newCustomer.ratioByAge[6]}%`,
				])
				} else {
				this.visitorDataset.datasets[0].data.push(0);
				if(anonymous) this.visitorDataset.datasets[1].data.push(0);
				this.visitorDataset.labels.push('');

				this.genderDataset.datasets[0].data.push(0);
				this.genderDataset.datasets[1].data.push(0);
				this.genderDataset.labels.push(['','']);
				this.manAndWomanRatioList.push(['','','','','','','','','','','','','','','',''])

				this.repeaterDataset.datasets[0].data.push(0);
				this.repeaterDataset.datasets[1].data.push(0);
				this.repeaterDataset.labels.push(['','']);
				this.newOrRepeatCustomersRatioList.push(['','','','','','','','','','','','','','','',''])
			}
		},
		async fetchWeatherData() {
			this.weatherLoading = true;
			console.log('areaCd :',this.areaCd);
      const hourList = await this.makeAxisHourList(this.leftSide, this.axisNum, 'weather');
			const dateList = await this.makeAxisDateList(this.params.from, this.axisNum);
      let fromParam = this.params.from;
      let toParam = this.params.to;

      if(this.mode == 'hour') {
        fromParam = fromParam.substring(0,10);
        toParam = toParam.substring(0,10);
      }

			this.networkController.getAnalyticsWeather({}, this.areaCd, fromParam, this.mode, toParam)
			.then(async (res) => {
				this.weatherDate = [];
				const weatherList = Object.keys(res.data.data).map(function (key) { 
					return { ...res.data.data[key], start: key }; 
				}); 
				console.log('%cWeatherData\n', "color:#008DD0;", weatherList);
				if(this.mode == 'hour') {
					hourList.forEach((hour) => {
						let hourIndex = weatherList.findIndex((el, idx, arr) => el.start == hour);
						let item = weatherList[hourIndex];
						if(hourIndex != -1) this.weatherDate.push(item);
						else this.weatherDate.push({ weather_cd: '5', temperature: '-' });
					});
				} else { // mode == day
					dateList.forEach((date) => {
						let dateIndex = weatherList.findIndex((el, idx, arr) => el.start == date);
						let item = weatherList[dateIndex];
						if(dateIndex != -1) this.weatherDate.push(item);
						else this.weatherDate.push({
							weather_cd: '500', max_temperature: '-', min_temperature: '-'
						});
					});
				}
				this.weatherLoading = false;
			}).catch(error => {
				this.weatherLoading = false;
				this.weatherVisible = false;
			});
		},
		checkModeFetchWeatherData() {
			if(this.period == 'today') {
				this.weatherVisible = true;
				this.fetchWeatherData();
			} else if(this.period == '7day') {
				if(this.mode == 'hour' || this.mode == 'day') {
					this.weatherVisible = true;
					this.fetchWeatherData();
				} else {
					this.weatherVisible = false;
				}
			} else if(this.period == '30day') {
				if(this.mode == 'hour' || this.mode == 'day') {
					this.weatherVisible = true;
					this.fetchWeatherData();
				} else {
					this.weatherVisible = false;
				}
			} else { // fromto
				if(this.mode == 'hour' || this.mode == 'day') {
					this.weatherVisible = true;
					this.fetchWeatherData();
				} else {
					this.weatherVisible = false;
				}
			}
		}
	}
};